import {
    CREATE_PALLET_ISSUE,
    DELETE_PALLET_ISSUE,
    GET_PALLET_ISSUE,
    PALLET_ISSUE_REQUEST,
    PALLET_ISSUE_REQUEST_FAILURE,
    UPDATE_PALLET_ISSUE,
    GET_PALLET_ISSUES_PAGE,
    PALLET_ISSUE_REQUEST_SUCCESS,
  } from "../types/pallet-issue-types";
  
  const initialState = {
    palletIssue: [],
    palletIssuesPage: [],
    availableTransactions: [],
    loading: false,
    error: null,
  };
  
  const palletIssueReducer = (state = initialState, action) => {
    switch (action.type) {
      case PALLET_ISSUE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_PALLET_ISSUE: {
        return {
          ...state,
          palletIssue: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_PALLET_ISSUES_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          palletIssuesPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_PALLET_ISSUE:
        return {
          ...state,
          palletIssue: [action.payload, ...state.palletIssue],
          loading: false,
          error: null
        };
      case UPDATE_PALLET_ISSUE:
        const palletIssueData = state.palletIssue.slice(0);
        const uIndex = palletIssueData.findIndex((data) => data.id === action.payload.id);
        palletIssueData.splice(uIndex, 1, { ...action.payload.data });
        
        return {
          ...state,
          palletIssue: [ ...palletIssueData ],
          loading: false,
          error: null
        };
      case DELETE_PALLET_ISSUE:
        const palletIssue = state.palletIssue?.slice(0);
        const index = palletIssue.findIndex((data) => data.id === action.id);
        if (index > -1) {
          palletIssue.splice(index, 1);
        }
        return {
          ...state,
          palletIssue: [...palletIssue],
          loading: false,
          error: null
        }
      case PALLET_ISSUE_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case PALLET_ISSUE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default palletIssueReducer;
  